module.exports = __webpack_public_path__ + "img/collage_img_01.b6c9a7de.jpg";